import { NextRequest, NextFetchEvent } from 'next/server';

import { logger } from '../utils/logger';

import { MiddlewareFactory } from './type';
import checkRailsSessionHistory from '../apis/rails/session-history';

export const railsSessionHistoryMiddleware: MiddlewareFactory = (next) => {
  return async (req: NextRequest, event: NextFetchEvent) => {
    const apiAccessToken = req.cookies.get('api-access-token')?.value;

    if (apiAccessToken) {
      event.waitUntil(
        checkRailsSessionHistory({ apiAccessToken }).catch((err) => logger.error(err))
      );
    }

    return next(req, event);
  };
};
